import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { consumerFields } from '../../constants/consumer';
import consumerTypeClassificator from '../../constants/classificators/consumerType';

const validatorRequiredCompany = () => (field, form) =>
  form.get(consumerFields.CONSUMER_TYPE) ===
  consumerTypeClassificator.MANUFACTURER
    ? validatorRequired()(field)
    : '';

const validatorRequiredPerson = () => (field, form) =>
  form.get(consumerFields.CONSUMER_TYPE) === consumerTypeClassificator.CONSUMER
    ? validatorRequired()(field)
    : '';

export default createValidation([
  {
    name: consumerFields.COMPANY_NAME,
    validators: (field, form) => validatorRequiredCompany()(field, form),
  },
  {
    name: consumerFields.EICX_CODE,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: consumerFields.REGISTER_CODE,
    validators: (field, form) => validatorRequiredCompany()(field, form),
  },
  {
    name: consumerFields.NAME,
    validators: (field, form) => validatorRequiredPerson()(field, form),
  },
  {
    name: consumerFields.PERSONAL_CODE,
    validators: (field, form) => validatorRequiredPerson()(field, form),
  },
  {
    name: consumerFields.CONSUMER_TYPE,
    validators: (field) => validatorRequired()(field),
  },
]);
